import { Category } from './models/category'

export default class CategoriesRepository {
    private _key: string | null;
    private _baseUrl: string;

    constructor (key: string | null, baseUrl: string) {
        this._key = key
        this._baseUrl = baseUrl
    }

    setKey(key: string | null) {
        this._key = key
    }

    async getCategories(): Promise<Category[]> {
        const response = await fetch(`${this._baseUrl}/categories`, {
            headers: {
                'Authorization': `Bearer ${this._key}`
            }
        })

        if (!response.ok) {
            throw new Error(response.statusText)
        }

        const json = await response.json()
        return json.data as Category[]
    }

    // returns the existing category when one with the same name is already defined
    async createCategory(name: string): Promise<Category> {
        const response = await fetch(`${this._baseUrl}/categories`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this._key}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name })
        })

        if (!response.ok) {
            throw new Error(response.statusText)
        }

        const json = await response.json()
        return json.data as Category
    }
}
